'use client';

import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';

interface ViewCounterProps {
  gameId: string;
  currentViews: number;
}

export function ViewCounter({ gameId, currentViews }: ViewCounterProps) {
  const [isInitialized, setIsInitialized] = useState(false);
  const searchParams = useSearchParams();
  const isAdmin = searchParams.get('admin') === 'true';

  useEffect(() => {
    if (isInitialized || isAdmin) return;

    try {
      const viewedGames = localStorage.getItem('viewed_games');
      const viewedGamesArray = viewedGames ? JSON.parse(viewedGames) : [];

      if (!viewedGamesArray.includes(gameId)) {
        // 조회수 증가 API 호출
        fetch(`/api/games/${gameId}/stats`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            type: 'views', 
            value: currentViews + 1 
          }),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('조회수 증가 실패');
          }
          // 조회한 게임을 localStorage에 추가
          viewedGamesArray.push(gameId);
          localStorage.setItem('viewed_games', JSON.stringify(viewedGamesArray));
        })
        .catch(error => {
          console.error('조회수 증가 실패:', error);
        });
      }
    } catch (error) {
      console.error('localStorage 접근 실패:', error);
    } finally {
      setIsInitialized(true);
    }
  }, [gameId, currentViews, isAdmin, isInitialized]);

  return null;
} 